export default __webpack_public_path__ + "static/media/app-store-download-badge.edeaacc2.png";